import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material';
import { BoxContainer } from '../layouts/Theme';
import useWidgetStore from '../store/useWidgetStore';
import useDataStore from '../store/useDataStore';
import { useForm } from 'react-hook-form';
import { FormContainer } from 'react-hook-form-mui';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
export default function RequiredProducts(props) {
    const theme = useTheme();
    const { t } = useI18N();
    const { enabled, setEnabled, cart, setCart } = useWidgetStore();
    const { products } = useDataStore();
    const [data, setData] = useState([]);
    const [hasRequiredProduct, setHasRequiredProduct] = useState(false);
    const flow = useFlow();
    useEffect(() => {
        if (!enabled.product) {
            setEnabled(Object.assign(Object.assign({}, enabled), { product: true }));
        }
    }, []);
    useEffect(() => {
        var _a;
        if (products) {
            let _data = products.filter((product) => product.requiredApp);
            setData(_data);
            if (_data.length === 1 && ((_a = _data[0].variances) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                // if we have only 1 required product, add it automatically and go to the next view
                let _lines = cart.lines;
                let _lineItem = {
                    name: _data[0].name,
                    price: _data[0].price,
                    quantity: 1,
                    productId: _data[0].id,
                    productType: "product",
                    origin: "requiredPurchase"
                };
                // check if we already have this product, if so remove it ( so we can update quantity)
                _lines = _lines.filter((line) => line.productId !== _data[0].id);
                // // add our new selection
                _lines.push(_lineItem);
                setCart(Object.assign(Object.assign({}, cart), { lines: _lines }));
            }
        }
    }, [products]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.route) === "requiredProducts") {
            let requiredProducts = cart.lines.filter((line) => line.origin === 'requiredPurchase');
            setHasRequiredProduct(requiredProducts.length > 0);
            if (requiredProducts.length > 0 && data.length === 1 && ((_b = data[0].variances) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                if ((_c = flow.previousRoute) === null || _c === void 0 ? void 0 : _c.route) {
                    if (!["select", "select1", "select2"].includes((_d = flow.previousRoute) === null || _d === void 0 ? void 0 : _d.route)) {
                        // @ts-ignore
                        //           flow?.onPrevious()
                    }
                    else {
                        // @ts-ignore
                        //         flow?.onNext()
                    }
                }
            }
        }
    }, [data, flow.currentRoute]);
    const formContext = useForm({});
    const onSubmit = (data, event) => {
        // form does nothing, is just here to provide a context for the pickers inside
        // @ts-ignore
        flow === null || flow === void 0 ? void 0 : flow.onNext();
    };
    const onError = (errors) => { };
    return (_jsx(_Fragment, { children: _jsxs(BoxContainer, { children: [_jsx(Typography, { children: "Voor nu, druk op volgende stap, er is automatisch een product toegevoegd maar er is een issue op dit scherm met het terug gedrag. Dus voor de demo, dit scherm zie je normaal niet." }), products && data && (_jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsxs(Fragment, { children: [cart.lines.length === 0 && (_jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Voeg ten minste 1 van deze producten toe.') })), !hasRequiredProduct && (
                            // <ObjectPicker source={"product"} data={data} config={{
                            //     toDetail: false,
                            //     action: "requiredPurchase",
                            //     types: ["product", "giftcard", "membership", "subcscription"],
                            // }
                            // } />
                            _jsx(_Fragment, {})), _jsx(Box, { sx: {
                                    position: 'absolute',
                                    bottom: '0',
                                    borderColor: theme.palette.divider,
                                    borderWidth: '1px 0 1px 0',
                                    borderStyle: "solid",
                                    left: '-16px',
                                    width: 'calc(100% - 32px)',
                                    paddingX: '32px',
                                    backgroundColor: theme.palette.background.paper,
                                    zIndex: 1000
                                }, children: _jsx(Button, { type: "submit", fullWidth: true, sx: {
                                        my: '16px'
                                    }, variant: "contained", disabled: !hasRequiredProduct, children: t("Volgende stap") }) })] }) }))] }) }));
}
